import { render, staticRenderFns } from "./zhuanjiaguahao.vue?vue&type=template&id=5fa65b15&scoped=true"
import script from "./zhuanjiaguahao.vue?vue&type=script&lang=js"
export * from "./zhuanjiaguahao.vue?vue&type=script&lang=js"
import style0 from "./zhuanjiaguahao.vue?vue&type=style&index=0&id=5fa65b15&prod&rel=stylesheet%2Fless&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa65b15",
  null
  
)

export default component.exports